import { lazy } from 'react';

// Design System
import { LoadingSpinner } from 'jl-design-system/components/loading-spinner/LoadingSpinner';

// Types
import { BatchedDeliveriesProps as LazyComponentProps } from './BatchedDeliveries.types';

// Components
import Container from '../container';
import withSuspense, { lazyRetry } from '../suspense';

const LazyComponent = lazy(() =>
  lazyRetry(() => import(/* webpackChunkName: "batchedDeliveries" */ './BatchedDeliveries')),
);

const FallbackComponent = (
  <Container background="white" flex={{ justifyContent: 'center' }} paddingY="3">
    <LoadingSpinner />
  </Container>
);

const LazyComponentWithSuspense = withSuspense<LazyComponentProps>(
  LazyComponent,
  'BatchedDeliveries',
  FallbackComponent,
);

// Exports
export default LazyComponentWithSuspense;
export { LazyComponent as BatchedDeliveries };
